import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { useBoundStore } from 'app/store';

import { savePatientInfo } from '../api';

export const useSubmitUserForm = () => {
  const patientInfoData = useBoundStore((state) => state.hsptlzForm.patientInfoData);
  const setPatientInfoData = useBoundStore((state) => state.hsptlzForm.setPatientInfoData);
  const navigate = useNavigate();

  const { mutate, isSuccess } = useMutation({
    mutationKey: ['savePatientInfo'],
    mutationFn: (data) => {
      setPatientInfoData({ ...patientInfoData, ...data });
      savePatientInfo(data);
    },
  });

  useEffect(() => {
    if (isSuccess) {
      navigate(patientInfoData.redirectUrl);
    }
  }, [isSuccess]);

  return { submit: mutate };
};
